import React from "react";
import { styles } from "assets/jss/default/views/errorPageStyles.js";
import makeStyles from "@mui/styles/makeStyles";
import NotFoundPage from "../pages/NotFound";
import PropTypes from "prop-types";
import InternalErrorPage from "../pages/InternalError";
import InvalidUserAccountConfiguration from "pages/InvalidUserAccountConfiguration";
import DownForMaintenance from "pages/DownForMaintenance";
import NoAccess from "pages/NoAccess";
const useStyles = makeStyles(styles);

export default function ErrorLayout(props) {
  const classes = useStyles();
  let pageToDisplay;

  if (props.match?.path === "/no-access") {
    pageToDisplay = <NoAccess />;
  } else if (props.match?.path === "*") {
    pageToDisplay = <NotFoundPage />;
  } else if (props.match?.path.indexOf("cke403") > -1) {
    pageToDisplay = <InvalidUserAccountConfiguration />;
  } else if (props.match?.path.indexOf("maintenance") > -1) {
    pageToDisplay = <DownForMaintenance />;
  } else {
    pageToDisplay = <InternalErrorPage />;
  }

  return (
    <div className={classes.wrapper}>
      <div className={classes.fullPage}>{pageToDisplay}</div>
    </div>
  );
}

ErrorLayout.propTypes = {
  match: PropTypes.object
};
